import React, { useState, useEffect } from 'react';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';

const CustomToasts = ({
  onClikHandlerOnComponent,
  componentClasses = 'table mr-3 my-1 max-w-xs shadow',
  componentStyle = {},
  OnCloseHandler,
  showCloseIcon = true,
  CustomCloseIcon,
  onMouseinHandler,
  onMouseOutHandler,
  textMessage = '',
  CustomMessages,
  onClickHandler,
  cardClasses = `w-full flex bg-blue-1300 rounded px-2 py-1 font-roboto shadow  ${props?.extraCardClasses}`,
  cardStyles = {},
  textMessageClasses = `contents text-center w-full text-xs text-blue-steelblue font-roboto   font-medium ${props?.extraTextMessageClasses}`,
  textMessageStyle,
  closeIconWrapperClasses = `ml-auto   cursor-pointer ${props?.extraCIWClasses}`,
  closeIconWrapperStyle = { marginRight: '-14px', marginTop: '-14px' },
  closeIconClasses = 'w-3 text-grey-1200',
  closeIconStyle = {},
  referName = '',
  ...props
}) => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    return () => setShow(true);
  }, []);
  return (
    //   Componenet Level
    <div
      className={`${componentClasses} ${!show && 'hidden'}`}
      style={componentStyle}
      onClick={() =>
        typeof onClikHandlerOnComponent == 'function' &&
        onClikHandlerOnComponent()
      }
      onMouseLeave={() =>
        typeof onMouseOutHandler == 'function' && onMouseOutHandler()
      }
      onMouseEnter={() =>
        typeof onMouseinHandler == 'function' && onMouseinHandler()
      }
    >
      {/* cardLevel */}
      <div
        className={`${cardClasses}`}
        style={cardStyles}
        onClick={() => typeof onClickHandler == 'function' && onClickHandler()}
      >
        {/* Message Area */}
        <p className={`${textMessageClasses}`} style={textMessageStyle}>
          {textMessage}
        </p>
        {CustomMessages && <CustomMessages />}
        {/* Close Icon Area */}
        <div
          className={`${closeIconWrapperClasses}`}
          style={closeIconWrapperStyle}
          onClick={() => {
            setShow(false);
            typeof OnCloseHandler == 'function' && OnCloseHandler(referName);
          }}
        >
          {/* Close Icon */}
          {showCloseIcon &&
            (CustomCloseIcon ? (
              <CustomCloseIcon />
            ) : (
              <CancelOutlinedIcon
                style={closeIconStyle}
                className={closeIconClasses}
              />
            ))}
        </div>
      </div>
    </div>
  );
};

export default CustomToasts;
